


















































import {defineComponent, onBeforeUnmount, ref, onMounted} from '@vue/composition-api'
import store from '@/store'
import axios from 'axios'
import {Message} from 'element-ui'
import {parseTime} from '@/utils/ruoyi'
import $ from 'jquery'
// import "animate.css"
import tilt from 'tilt.js/src/tilt.jquery.js'

export default defineComponent({
  mixins: [tilt],
  setup() {
    const img1 = require('../assets/sites/icon_dingze.png')
    const img2 = require('../assets/sites/icon_tiaojie.png')
    const img3 = require('../assets/sites/icon_jiuyuan.png')
    const img4 = require('../assets/sites/icon_lipei.png')
    const img5 = require('../assets/sites/icon_shitong.png')
    const img6 = require('../assets/sites/icon_xuanjiao.png')
    // const imgList = ref([img1, img2, img3, img4, img5])
    const imgList = ref([img1, img2, img3, img4, img5, img6])
    const list = ref([])
    const time = ref(parseTime(Date.now(), undefined))
    time.value = time.value.substr(0, 16).replace(/\-/g, '/')
    // const interval = setInterval(() => {
    //   time.value = parseTime(Date.now(),undefined);
    // }, 1000);
    const hasToken = store.getters.token
    const roles = store.getters.roles;
    (document.body as HTMLDivElement).style.overflowX = 'hidden'
    axios.get('/sites').then((data) => {
      list.value = data.data.data
      localStorage.setItem('sites', JSON.stringify(list.value))
    })
    onMounted(() => {
      $('.js-tilt').tilt({
        scale: 1.05
      })
    })
    // onBeforeUnmount(() => {
    //   clearInterval(interval);
    // });
    const init = () => {
      const str = localStorage.getItem('sites')
      if (str) {
        list.value = JSON.parse(str)
      }
    }
    const to = (item) => {
      // if (item.dictCode === 3185 || item.dictLabel === '远程调解') {
      //   window.location.href = item.dictValue
      // } else {
        if (hasToken) {
          // 已经登录,根据用户roles判断是否有权限登录
          let hasPermissions = false
          item.loginType && item.loginType.split(',').forEach(el => {
            roles.forEach(role => {
              if (el === role || role === 'admin') {
                hasPermissions = true
              }
            })
          })
          if (hasPermissions) {
            if (location.host === 'localhost' && item.dictValue !== 'https://sos.didisos.cn/datav/yancheng_bxhyxh.html') {
              window.location.href = '/index'
            } else {
              window.location.href = item.dictValue
            }
          } else {
            Message.error('该账号无此系统权限')
            return
          }
        } else {
          localStorage.setItem('loginType', item.dictCode)
          // 未登录直接跳转登录,由后台判断是否有权限登录
          if (location.host === 'localhost' && item.dictValue !== 'https://sos.didisos.cn/datav/yancheng_bxhyxh.html') {
            window.location.href = '/index'
          } else {
            window.location.href = item.dictValue
          }
          console.log(item.dictValue)
        }
      // }
    }
    init()
    return {
      to,
      time,
      list,
      hasToken,
      imgList
    }
  },
})
